import React, { useContext } from "react";
import BtnPlain from "../../../../../../../Components/Buttons/BtnPlain";
import useAxios from "../../../../../../../Hooks/useAxios";
import useApp from "../../../../../../../Hooks/useApp";
import TableContext from "./TContext";
import { FaRegTrashAlt } from "react-icons/fa";

const TableActions = ({ doc, sid }) => {
  const request = useAxios();
  const { setShowSuccessModal, setModalMessage } = useApp();
  const { data, setData,getSpaceInventories } = useContext(TableContext);

  const handleDelete = async () => {
    let res = await request({
      method: "DELETE",
      url: `hospital/space/assign/${parseInt(sid)}`,
    });

    if (res !== "error") {
      setModalMessage("User Removed!");
      setShowSuccessModal(true);
      getSpaceInventories()
    }
    getSpaceInventories()
  };

  return (
    <div className="flex-1">
      <div className=" gap-y-2 flex flex-col text-sm">
        <BtnPlain activeBgColor="white" bg="white" click={handleDelete}>
          <div className=" gap-x-2 flex items-center active:opacity-50 cursor-pointer">
            <p className="  text-red">
              <FaRegTrashAlt />
            </p>
            <p className=" "> </p>
          </div>
        </BtnPlain>
      </div>
    </div>
  );
};

export default TableActions;
